import { RootState } from 'typesafe-actions'

export const getIntegrations = (state: RootState): any | undefined => state.integrations

export const getIntegration = (key: string) => (state: RootState): any | undefined =>
  getIntegrations(state)?.status[key]
